export default __webpack_public_path__ + "static/media/installIos.178659e5.png";